import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import * as SocioCrud from 'services/socio.service'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting, values, setValues }) => {
  const [generandoCodigo, setGenerandoCodigo] = React.useState(false)

  const generarCodigoClickHandler = React.useCallback(() => {
    setGenerandoCodigo(true)
    SocioCrud.getNuevoCodigo().then(({ data }) => {
      setGenerandoCodigo(false)
      values.codigo = data.nuevoCodigo
      setValues(values)
    })
  }, [values, setValues])

  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={2} />
      <Col md={10}>
        <Form.InputGroup>
          <Field name='codigo'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-codigo'
                isInvalid={iTouched && iError}
                placeholder='Generar código ...'
                disabled
              />
            )}
          </Field>
          <Form.InputGroup.Append>
            <Button
              disabled={fIsSubmitting || generandoCodigo}
              color='secondary'
              outline
              onClick={generarCodigoClickHandler}
            >
              Generar
            </Button>
          </Form.InputGroup.Append>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
